import React, {useState, useEffect} from 'react';
import BlockHeadlineComponent from '../Headline/BlockHeadlineComponent';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import { stepEnum } from '../ChangePricePlanConsts';
import TextFieldWithRadio from '../../../Shared/TextFieldWithRadio/TextFieldWithRadio';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {
    gAChangePPContractBySmsLimited,
    gAChangePPContractBySms,
    gAChangePPContractPageLimited,
    gAChangePPContractPage,
    gAChangePPContractByMailLimited,
    gAChangePPContractByMail,
} from './../reports/gaReports';
import {buildUrlAndOpenWindow} from '../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../Config';
import {gtag4} from '../../../../utilities/analytics/tracking';
import {
    dwhContractPageDisplay,
    dwhContractPagePhoneButtonClick,
    dwhContractPageEmailButtonClick,
    dwhContractPageButtonClick, dwhThirdPartyConsentCheckboxDisplay,
} from '../reports/dwhReports';
import ThirdParty from '../../../Shared/ThirdParty/ThirdParty';


const ResponseContactForm = ({props, createRequestAndSend}) => {
    //DWH params
    const newOfferId = props.data.selectedAccount.newPackage?.offerID;
    const currentOfferId = props.data.selectedAccount.pricePlan;
    const subscriber = props.userData.loginData?.userDetails.contactNumber;
    const pageURL = window.location.href;
    const customerName = `${props.userData.loginData?.userDetails?.firstName} ${props.userData.loginData?.userDetails?.lastName}`;
    const id = props.userData.loginData?.userDetails?.IDNumber;
    let phoneNumber = props.data.selectedAccount.subscriberNo;
    if (props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
        phoneNumber = props.data.selectedAccountExtendedData.associatedSubscriberList
            .map((sub) => {
                return sub.subscriberNo;
            })
            .join(',');
    }
    const defaultCheckBoxes = [
        // {
        //   id: 'agreeCantGoBack',
        //   label: 'אני מאשר שיודע שברגע שאעבור לחבילה חדשה לא תהיה באפשרותי לחזור לחבילה הישנה שלי',
        //   checked: false,
        // },
        {
            id: 'agreeReceiveReceiptToMail',
            label: 'אני רוצה לקבל את החשבונית למייל שהזנתי אחרת תשלח החשבונית לכתובת המגורים שמילאת',
            checked: false,
        },
        {
            id: 'agreeToPlanTerms',
            label: (
                <>
                    קראתי ואני מסכים{' '}
                    <a href='#' className='pink-text'
                       onClick={() => buildUrlAndOpenWindow(props.data.selectedAccount?.newPackage?.termsLink)}>
                        לעיקרי פרטי התכנית
                    </a>
                    ,{' '}
                    <a
                        href='#'
                        className='pink-text'
                        onClick={() => (Config.cooperationPrivacyPolicyLink ? buildUrlAndOpenWindow(Config.cooperationPrivacyPolicyLink) : null)}>
                        להסכם ההתקשרות
                    </a>{' '}
                    <a
                        href='#'
                        className='pink-text'
                        onClick={() => (Config.cooperationTermsLink ? buildUrlAndOpenWindow(Config.cooperationTermsLink) : null)}>
                        ולתנאים הכלליים
                    </a>
                </>
            ),
            checked: false,
        },
    ];

    const [checkBoxes, setCheckBoxes] = useState(defaultCheckBoxes);

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            if (typeof window.scrollTo === 'function') {
                window.scrollTo(0, 0);
            }

            //GA old
            if (props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
                gAChangePPContractPageLimited();
            } else {
                gAChangePPContractPage();
            }
            //GA 4
            if (!props.data.selectedMarketPackage) {
                gtag4({
                    event: 'CellPackUpdateP2_Step13_AgreementConfirmationPage',
                    step: '13',
                    action: 'AgreementConfirmationPage',
                    title: 'לאן לשלוח את ההסכם החדש ?',
                });
            } else {
                gtag4({
                    event: 'CellPackUpdateP1_Step10_AgreementConfirmationPage',
                    step: '10',
                    action: 'AgreementConfirmationPage',
                    title: 'לאן לשלוח את ההסכם החדש ?',
                });
            }
            //DWH
            let param6 = props.data.showSignCollaboration;
            dwhContractPageDisplay({
                newOfferId,
                currentOfferId,
                subscriber,
                pageURL,
                customerName,
                id,
                phoneNumber,
                param6
            });
            if (props.data.showSignCollaboration) {
                dwhThirdPartyConsentCheckboxDisplay(customerName, phoneNumber, id, "מעבר תכנית")
            }
            setTimeout(() => {
                props.saveToHistory('form');
            }, 1000);
        }
    }, []);

    const validateAndSend = () => {
        const agreeReceiveReceiptToMail = checkBoxes.find((chb) => chb.id == 'agreeReceiveReceiptToMail')?.checked;
        const shatap = props.data.showSignCollaboration ? (props.data.collaborationApproval ? 'Shatap true' : 'Shatap false') : '';
        if (props.data.selectedForm == 'phone' && props.data.form.phone.valid) {
            //GA old
            if (props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
                gAChangePPContractBySmsLimited();
            } else {
                gAChangePPContractBySms();
            }
            //GA 4
            if (!props.data.selectedMarketPackage) {
                gtag4({
                    event: 'CellPackUpdateP2_Step14_AgreementConfirmationButton',
                    step: '14',
                    action: 'AgreementConfirmationButton',
                    title: 'לאן לשלוח את ההסכם החדש ?',
                    button: 'אישור',
                });
            } else {
                gtag4({
                    event: 'CellPackUpdateP1_Step11_AgreementConfirmationButton',
                    step: '11',
                    action: 'AgreementConfirmationButton',
                    title: 'לאן לשלוח את ההסכם החדש ?',
                    button: 'אישור',
                });
            }
            let param4 = props.data.form.phone.phone;
            dwhContractPageButtonClick({
                newOfferId,
                currentOfferId,
                subscriber,
                pageURL,
                customerName,
                id,
                phoneNumber,
                param4,
                shatap
            });
            createRequestAndSend(agreeReceiveReceiptToMail);
        } else if (props.data.selectedForm == 'email' && props.data.form.email.valid) {
            if (props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y') {
                gAChangePPContractByMailLimited();
            } else {
                gAChangePPContractByMail();
            }
            const param4 = props.data.form.email.email;
            dwhContractPageButtonClick({
                newOfferId,
                currentOfferId,
                subscriber,
                pageURL,
                customerName,
                id,
                phoneNumber,
                param4,
                shatap
            });
            createRequestAndSend(agreeReceiveReceiptToMail);
        } else {
            if (props.data.selectedForm == 'phone') {
                handleFieldChange({field: 'phone', value: ''});
            } else {
                handleFieldChange({field: 'email', value: ''});
            }
        }
    };

    const onCheck = () => {
        props.setCollaborationApproval(!props.data.collaborationApproval);
    };

    const handleCheck = (id) => {
        setCheckBoxes(
            checkBoxes.map((checkBox) => (checkBox.id === id ? {...checkBox, checked: !checkBox.checked} : {
                ...checkBox,
                error: ''
            }))
        );
    };

    useEffect(() => {
        props.data.selectedForm === 'phone'
            ? setCheckBoxes(checkBoxes.filter((checkBox) => checkBox.id !== 'agreeReceiveReceiptToMail'))
            : props.data.showInvoiceByEmail
                ? setCheckBoxes((previousState) => [
                    ...previousState,
                    previousState.findIndex((checkBox) => checkBox.id === 'agreeReceiveReceiptToMail') === -1 ? defaultCheckBoxes[0] : previousState,
                ])
                : null;
    }, [props.data.selectedForm]);

    const handleSetSelectedForm = (id) => {
        if (id == props.data.selectedForm) return;
        //DWH
        if (id == 'phone') {
            dwhContractPagePhoneButtonClick({
                newOfferId,
                currentOfferId,
                subscriber,
                pageURL,
                customerName,
                id,
                phoneNumber
            });
        } else {
            dwhContractPageEmailButtonClick({
                newOfferId,
                currentOfferId,
                subscriber,
                pageURL,
                customerName,
                id,
                phoneNumber
            });
        }
        props.setSelectedForm(id);
    };

    function handleFieldChange({field, value}) {
        //dwh
        props.changeHandler({
            name: field,
            value: value,
            rule: props.data.form[field].rules[field],
        });
    }

    return (
        !props.data.callbackRequest && (
            <div className={` response-container m-auto`}>
                <div className='mt-5 mr-auto ml-auto'>
                    <BlockHeadlineComponent mainText={'לאן לשלוח את ההסכם החדש ?'}
                                            currentStep={props.data.currentStep}/>
                </div>

                <TextFieldWithRadio
                    fields={props.data.form}
                    onChange={handleFieldChange}
                    selectedForm={props.data.selectedForm}
                    setSelectedForm={handleSetSelectedForm}
                />

                <div className='check-boxes-area'>
                    {checkBoxes.map((checkBox) => (
                        <CheckBox
                            key={checkBox.id}
                            id={checkBox.id}
                            onCheck={(e) => handleCheck(e)}
                            onUncheck={(e) => handleCheck(e)}
                            //label={checkBox.label}
                            checked={checkBox.checked}>
                            {checkBox.label}
                        </CheckBox>
                    ))}
                    {props.data.showSignCollaboration && (
                        <CheckBox
                            id='agreementCheckbox'
                            onCheck={onCheck}
                            onUncheck={onCheck}
                            checked={props.data.collaborationApproval}
                            label={<ThirdParty/>}
                        />
                    )}
                </div>

                <div className={`m-auto text-center ${!checkBoxes[0]?.checked ? 'disabled' : ''}`}>
                    <BtnSubmit text='אישור וסיום' onclick={() => validateAndSend()}/>
                </div>
            </div>
        )
    );
};

export default ResponseContactForm;
